import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/QueryZoiActionTypes";
import _ from "lodash";
import Toast from "../../components/assetLibComponents/shared/Toast";
import { findLastIndex } from "lodash";

export const setLiveChatUnauthorized = () => {
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_CHAT_AI", payload: null });
    };
};


export const setListingData = () => {
    return (dispatch) => {
        dispatch({ type: "FETCH_MAIN_CHAT_LISTING", payload: null });
    };
};

// Fetch chat history listing

export const fetchChatHistoryListing = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get(
        "ama/get-message",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_HISTORY_CHAT_LISTING,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      // dispatch({
      //   type: "UNAUTHORIZED_CHAT_AI",
      //   payload: err.response.status,
      // });
    }
  };
};

// fetch chat main listing 

export const fetchMainChatListing = (authToken, token, path, onSuccessResponse) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false }); 
    try {
      const response = await storeApis.post(
        "ama/get-message",
        {
          prospect_token: token
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_MAIN_CHAT_LISTING,
            payload: response.data,
          });
          if (path === "inner") {
            onSuccessResponse();
            dispatch({ type: "AMA_TOGGLE_LOADING", payload: false });
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
    }
  };
};


// send message from ama bar 
export const addMessageQuery = (authToken, prompt, length, token, onSuccessResponse) => {
  return async (dispatch) => {
    dispatch({ type: "AMA_TOGGLE_LOADING", payload: true });
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "ama/send-message",
        {
          prompt: prompt,
          answer_length: length,
          prospect_token: token,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "AMA_TOGGLE_LOADING", payload: false });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchChatHistoryListing(authToken));
          dispatch(fetchMainChatListing(authToken, token, "inner", onSuccessResponse));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

export const fetchNewSuggestion = (authToken, token, prompt_id, onSuccessResponse) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "refresh_suggestion",
        {
          action:"admin-ama",
          prospect_token: token,
          new_prompt_id: prompt_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(fetchMainChatListing(authToken, token, "inner", onSuccessResponse));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};

// Clean Chat history 
export const cleanChatHistory = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get(
        "ama/clear-chat",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // dispatch({
          //   type: "UNAUTHORIZED_CHAT_AI",
          //   payload: response.data.statusCode,
          // });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch(fetchChatHistoryListing(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      // dispatch({
      //   type: "UNAUTHORIZED_CHAT_AI",
      //   payload: err.response.status,
      // });
    }
  };
};

// Clean Chat history 
export const fetchQuickQuery = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get(
        "home_prompts/view",
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          //debugger;
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          return response.data?.data?.prompts;
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
    }
  };
};

export const deleteChat = (authToken,p_token) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "ama/clear-chat",
        {
          prospect_token: [p_token]
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};
export const fetchCannedListing = (authToken,code) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "canned-response/search",
        {
          keyword: code
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_CHAT_AI",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
            type: types.FETCH_CANNED_DOCS,
            payload: response.data?.details,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_CHAT_AI",
        payload: err.response.status,
      });
    }
  };
};
